import { getAnalyticsClient, uuidv4 } from '../wrappers';
import { getSegmentKey } from '../../constants';

let anonymousId: string | undefined;

export const getAnonymousId = () => {
  if (!anonymousId) {
    anonymousId = createAnonymousId();
  }
  return anonymousId;
};

export const setAnonymousId = (id: string) => (anonymousId = id);

export const track = ({
  event,
  userId,
  properties,
}: {
  event: string;
  userId?: string;
  properties: { [name: string]: string | number };
}) => {
  const trackingData = appendIdentity({ event, properties }, userId);
  getAnalyticsClient(getSegmentKey()).track(trackingData);
};

export const page = ({
  name,
  userId,
  properties,
}: {
  name: string;
  userId?: string;
  properties: { [name: string]: string | number };
}) => {
  const trackingData = appendIdentity({ name, properties }, userId);
  getAnalyticsClient(getSegmentKey()).page(trackingData);
};

export const identifyAnonymous = () =>
  getAnalyticsClient(getSegmentKey()).identify({
    anonymousId: getAnonymousId(),
  });

export const identifyUser = (userId: string) =>
  getAnalyticsClient(getSegmentKey()).identify({
    userId,
    anonymousId: getAnonymousId(),
  });

export const indetifyUserPromise = (userId: string) => {
  return new Promise(resolve => {
    getAnalyticsClient(getSegmentKey()).identify({ userId }, resolve);
  });
};

export const clearAnonymousId = () => (anonymousId = undefined);

const createAnonymousId = () => setAnonymousId(uuidv4());

const appendIdentity = <T extends object>(trackingData: T, userId?: string) => {
  if (userId) {
    return Object.assign(trackingData, { userId });
  }

  return Object.assign(trackingData, { anonymousId: getAnonymousId() });
};
